import { createSlice } from '@reduxjs/toolkit';
import {
  editLotteryBrandDays,
  getAllLotteryBrandDay,
  getAllLotteryBrandDaysCode,
  newLotteryBrandDays,
} from './lotteryBrandDayService';

const initialState = {
  allLotteryBrandDay: {
    isLotteryBrandDayLoading: null,
    isLotteryBrandDaySuccess: null,
    lotteryBrandDayMessage: null,
    pageCount: 0,
    lotteryBrandDay: [],
  },
  lotteryBrandDays: {
    islotteryBrandDaysCreating: null,
    islotteryBrandDaysCreated: null,
    lotteryBrandDaysCreationMsg: null,
  },
  editLotteryBrandDays: {
    isEditingLotteryBrandDays: null,
    isLotteryBrandDaysEdited: null,
    lotteryBrandDaysEditedMsg: null,
  },
  allLotteryBrandDayCode: {
    isLotteryBrandDayCodeLoading: null,
    isLotteryBrandDayCodeSuccess: null,
    lotteryBrandDayCodeMessage: null,
    pageCount: 0,
    lotteryBrandDayCode: [],
  },
};

const LotteryBrandDaySlice = createSlice({
  name: 'lotteryBrandDay',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllLotteryBrandDay.pending, (state) => {
        state.allLotteryBrandDay = {
          ...initialState.allLotteryBrandDay,
          isLotteryBrandDayLoading: true,
          lotteryBrandDayMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllLotteryBrandDay.rejected, (state, action) => {
        state.allLotteryBrandDay = {
          ...initialState.allLotteryBrandDay,
          isLotteryBrandDayLoading: false,
          isLotteryBrandDaySuccess: false,
          lotteryBrandDayMessage:
            action.payload ||
            'Error occurred while fetching lottery brand days',
        };
      })

      // FULFILLED
      .addCase(getAllLotteryBrandDay.fulfilled, (state, action) => {    
        state.allLotteryBrandDay = {
          ...initialState.allLotteryBrandDay,
          isLotteryBrandDayLoading: false,
          isLotteryBrandDaySuccess: true,
          pageCount: action.payload.pageCount || 0,
          lotteryBrandDay: action.payload || [],
        };
      });

    //Lottery creating
    builder
      .addCase(newLotteryBrandDays.pending, (state) => {
        state.lotteryBrandDays = {
          ...initialState.lotteryBrandDays,
          islotteryBrandDaysCreating: true,
          lotteryBrandDaysCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(newLotteryBrandDays.rejected, (state, action) => {
        state.lotteryBrandDays = {
          ...initialState.lotteryBrandDays,
          islotteryBrandDaysCreating: false,
          islotteryBrandDaysCreated: false,
          lotteryBrandDaysCreationMsg:
            action.payload ||
            'Error occurred while creating the lottery brand days.',
        };
      })

      // FULFILLED
      .addCase(newLotteryBrandDays.fulfilled, (state, action) => {
        state.lotteryBrandDays = {
          ...initialState.lotteryBrandDays,
          islotteryBrandDaysCreating: false,
          islotteryBrandDaysCreated: true,
          lotteryBrandDaysCreationMsg:
            action.payload || 'Successfully created the lottery brand days.',
        };
      });

    //    //Lottery editing
    builder
      .addCase(editLotteryBrandDays.pending, (state) => {
        state.editLotteryBrandDays = {
          ...initialState.editLotteryBrandDays,
          isEditingLotteryBrandDays: true,
          lotteryBrandDaysEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editLotteryBrandDays.rejected, (state, action) => {
        state.editLotteryBrandDays = {
          ...initialState.editLotteryBrandDays,
          isEditingLotteryBrandDays: false,
          isLotteryBrandDaysEdited: false,
          lotteryBrandDaysEditedMsg:
            action.payload ||
            'Error occurred while editing the lottery brand days.',
        };
      })

      // FULFILLED
      .addCase(editLotteryBrandDays.fulfilled, (state, action) => {
        state.editLotteryBrandDays = {
          ...initialState.editLotteryBrandDays,
          isEditingLotteryBrandDays: false,
          isLotteryBrandDaysEdited: true,
          lotteryBrandDaysEditedMsg:
            action.payload || 'Successfully edited the lottery brand days.',
        };
      });

    builder
      .addCase(getAllLotteryBrandDaysCode.pending, (state) => {
        state.allLotteryBrandDayCode = {
          ...initialState.allLotteryBrandDayCode,
          isLotteryBrandDayCodeLoading: true,
          lotteryBrandDayCodeMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllLotteryBrandDaysCode.rejected, (state, action) => {
        state.allLotteryBrandDayCode = {
          ...initialState.allLotteryBrandDayCode,
          isLotteryBrandDayCodeLoading: false,
          isLotteryBrandDayCodeSuccess: false,
          lotteryBrandDayCodeMessage:
            action.payload ||
            'Error occurred while fetching lottery brand days code',
        };
      })

      // FULFILLED
      .addCase(getAllLotteryBrandDaysCode.fulfilled, (state, action) => {
        state.allLotteryBrandDayCode = {
          ...initialState.allLotteryBrandDayCode,
          isLotteryBrandDayCodeLoading: false,
          isLotteryBrandDayCodeSuccess: true,
          pageCount: action.payload.pageCount || 0,
          lotteryBrandDayCode: action.payload || [],
        };
      });
  },
});

export default LotteryBrandDaySlice.reducer;
